import Plan from "../atoms/Plan";
import top from "../../images/planes/top-planes-home.png";
import "./Planes.css";

import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/effect-cards";
import "swiper/css/free-mode";

import { useEffect, useState } from "react";
import { IPlan } from "../../types/subscription";
import { getAllSubscriptions } from "../../services/subscription.service";

export const Planes = () => {
  const useWindowWidth = () => {
    const [windowWidth, setWindowWidth] = useState(window.innerWidth);

    useEffect(() => {
      const handleResize = () => {
        setWindowWidth(window.innerWidth);
      };

      window.addEventListener("resize", handleResize);

      return () => {
        window.removeEventListener("resize", handleResize);
      };
    }, []);

    return windowWidth;
  };

  const [subscriptions, setSubscriptions] = useState<IPlan[]>([])
  
  useEffect(()=>{
    getAllSubscriptions().then(
      res => {
        setSubscriptions(res);
      }
    ).catch((error) => {
      console.error(subscriptions);
    })
  },[])

  const windowWidth = useWindowWidth();

  return (
    <div id="planes">
      <div className="planes-container">
        <img className="planes-image-top" src={top} alt="Top planes" />
      </div>

      <h1 style={{ marginBottom: "30px" }}>Conocé nuestros Planes</h1>

      <div
        className="planes-container"
        style={{ width: "100%", minWidth: "350px" }}
      >
        {windowWidth <= 700 ? (
          <Swiper
            spaceBetween={-30}
            slidesPerView={"auto"}
            centeredSlides={true}
            modules={[Pagination]}
            pagination={{ clickable: true }}
          >
            {subscriptions.map((plan, index) => (
              <SwiperSlide style={{ display: "flex", maxWidth: "350px" }}>
                <Plan full={true} subscription={plan} />
              </SwiperSlide>
            ))}
          </Swiper>
        ) : (
          <>
            {subscriptions.map((plan) => (
              <Plan full={true} subscription={plan} key={plan.id}/>
            ))}

          </>
        )}
      </div>
      <div className="planes-container">* Próximamente...</div>
    </div>
  );
};

export default Planes;
